import get from 'lodash/get';

import { DesignTokenColor, palette } from '@src/theme/medelyPalette';

export const colorStringToPalette = (colorToken: DesignTokenColor): string => {
  return get(palette, colorToken);
};
